export const getNotifications = state => state.notification;
